import { PersonCommentsDTO } from "../dto/PersonCommentsDTO";
import { PersonComment } from "../models/Person/PersonComment";
import { useUtility } from "@/composables/useUtility";

const { formatDateNY } = useUtility();

export const personCommentsMapper = (data: PersonCommentsDTO) => {
  const { commentId, personId, author, comments, createdOn, updatedOn } = data;
  const action = createdOn !== updatedOn ? "Edited" : "Added";
  const commentDetails = `${action} by ${author} on ${formatDateNY(updatedOn)}`;

  return new PersonComment({
    commentId: commentId,
    personId: personId,
    author: author,
    comments: comments,
    createdOn: createdOn,
    updatedOn: updatedOn,
    commentDetails: commentDetails,
  });
};
